import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SortDropdown = ({ currentSort, onSortChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const sortOptions = [
    { value: 'relevance', label: 'Relevancia', icon: 'Target' },
    { value: 'price-asc', label: 'Precio: Menor a Mayor', icon: 'ArrowUp' },
    { value: 'price-desc', label: 'Precio: Mayor a Menor', icon: 'ArrowDown' },
    { value: 'newest', label: 'Más Recientes', icon: 'Clock' },
    { value: 'popularity', label: 'Más Populares', icon: 'TrendingUp' },
    { value: 'rating', label: 'Mejor Valorados', icon: 'Star' },
    { value: 'title', label: 'Título A-Z', icon: 'AlphabeticalOrder' }
  ];

  const currentOption = sortOptions?.find(option => option?.value === currentSort) || sortOptions?.[0];

  const handleSortSelect = (sortValue) => {
    onSortChange(sortValue);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        iconName="ChevronDown"
        iconPosition="right"
        iconSize={16}
        className="text-xs sm:text-sm min-h-[44px]"
      >
        <Icon name={currentOption?.icon} size={16} className="mr-2" />
        <span className="hidden sm:inline">{currentOption?.label}</span>
        <span className="sm:hidden">Ordenar</span>
      </Button>
      {isOpen && (
        <>
          {/* Overlay for mobile */}
          <div 
            className="fixed inset-0 z-40 lg:hidden" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown Menu */}
          <div className="absolute right-0 top-full mt-2 w-64 bg-popover border border-border rounded-md shadow-modal py-1 z-50">
            {sortOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => handleSortSelect(option?.value)}
                className={`w-full flex items-center px-4 py-3 text-sm text-left transition-smooth min-h-[44px] ${
                  currentSort === option?.value
                    ? 'bg-muted text-primary font-medium' :'text-popover-foreground hover:bg-muted'
                }`}
              >
                <Icon name={option?.icon} size={16} className="mr-3 flex-shrink-0" />
                <span className="truncate">{option?.label}</span>
                {currentSort === option?.value && (
                  <Icon name="Check" size={16} className="ml-auto text-primary flex-shrink-0" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SortDropdown;
